import React from 'react';
import { H4 } from '@rezdy/components/Heading';

import { ResendConfirmationCode } from './ResendConfirmationCode';
import { ContactSupport } from '../../components/ContactSupport';
import { WithTranslation } from 'react-i18next';
export type ErrorCode =
    | 'EXPIRED_REFRESH_TOKEN'
    | 'INVALID_VERIFICATION_CODE'
    | 'EXPIRED_VERIFICATION_CODE'
    | 'COGNITO_PROFILE_UPDATE_ERROR'
    | 'UNKNOWN';

interface ExpiredConfirmationProps extends WithTranslation {
    email: string;
}

export function ExpiredConfirmation({ email, t, i18n, tReady }: ExpiredConfirmationProps) {
    const translationProps = { t, i18n, tReady };
    return (
        <>
            <H4>{i18n.t('errors.expiredConfirmation.confirmationLinkExpired')}</H4>
            <p>{i18n.t('errors.expiredConfirmation.getNewConfirmation')}</p>
            <ResendConfirmationCode {...translationProps} />
        </>
    );
}

export function InvalidCode({ i18n }: WithTranslation) {
    return (
        <>
            <H4>{i18n.t('errors.invalidCode.heading')}</H4>
            <p>{i18n.t('errors.invalidCode.tryAgain')}</p>
            <ContactSupport />
        </>
    );
}

export function Generic({ i18n }: WithTranslation) {
    return (
        <>
            <H4>{i18n.t('errors.emailGeneric.heading')}</H4>
            <p>{i18n.t('errors.emailGeneric.unableToProcess')}</p>
            <p>{i18n.t('errors.emailGeneric.tryAgain')}</p>
            <ContactSupport />
        </>
    );
}

interface ChangeEmailErrorProps {
    errorCode: ErrorCode;
    email: string;
}

export function ChangeEmailError({ errorCode, email, i18n, t, tReady }: ChangeEmailErrorProps & WithTranslation) {
    const translationProps = { i18n, t, tReady };

    switch (errorCode) {
        case 'EXPIRED_REFRESH_TOKEN':
            return <ExpiredConfirmation email={email} {...translationProps} />;
        case 'INVALID_VERIFICATION_CODE':
            return <InvalidCode {...translationProps} />;
        default:
            return <Generic {...translationProps} />;
    }
}
